import { Controller } from '@hotwired/stimulus'

export default class AppInstallBannerController extends Controller {
  static targets = [
    'banner',
    'installButton'
  ];

  static values = {
    storeUrl: String,
  };

  connect() {
    this.displayBanner();
  }

  async displayBanner() {
    if (Median.isNativeApp() || sessionStorage.getItem('app_install_banner_hidden') === 'true') {
      return;
    }

    this.installButtonTarget.setAttribute('href', this.storeUrlValue);
    this.bannerTarget.classList.remove('d-none');
  }

  hideBanner() {
    this.bannerTarget.classList.add('d-none');
    sessionStorage.setItem('app_install_banner_hidden', true);
  }
}
